import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { Heading, InlineLink, Paragraph, Section, Wrapper } from "./style"

export const NiepolomicePlotsContent: React.FC = () => {
  const { t } = useTranslation("index", {
    keyPrefix: "components.seoLandingPage.niepolomicePlots",
  })

  return (
    <Section>
      <Wrapper>
        <Paragraph>{t("paragraph1")}</Paragraph>
        <Paragraph>{t("paragraph2")}</Paragraph>

        <Heading>{t("heading1")}</Heading>
        <Paragraph>{t("paragraph3")}</Paragraph>
        <Paragraph>{t("paragraph4")}</Paragraph>

        <Heading>{t("heading2")}</Heading>
        <Paragraph>{t("paragraph5")}</Paragraph>
        <Paragraph>{t("paragraph6")}</Paragraph>

        <Heading>{t("heading3")}</Heading>
        <Paragraph>
          <Trans
            t={t}
            i18nKey="paragraph7"
            components={{
              valuationLink: <InlineLink to="/uslugi/wycena/" />,
            }}
          />
        </Paragraph>
      </Wrapper>
    </Section>
  )
}

export const NiepolomiceHousesContent: React.FC = () => {
  const { t } = useTranslation("index", {
    keyPrefix: "components.seoLandingPage.niepolomiceHouses",
  })

  return (
    <Section>
      <Wrapper>
        <Paragraph>{t("paragraph1")}</Paragraph>
        <Paragraph>{t("paragraph2")}</Paragraph>

        <Heading>{t("heading1")}</Heading>
        <Paragraph>{t("paragraph3")}</Paragraph>
        <Paragraph>{t("paragraph4")}</Paragraph>

        <Heading>{t("heading2")}</Heading>
        <Paragraph>{t("paragraph5")}</Paragraph>

        <Heading>{t("heading3")}</Heading>
        <Paragraph>
          <Trans
            t={t}
            i18nKey="paragraph6"
            components={{
              valuationLink: <InlineLink to="/uslugi/wycena/" />,
            }}
          />
        </Paragraph>
      </Wrapper>
    </Section>
  )
}
